import { CSSProperties } from 'react';
import { pick } from 'lodash';
import { ChevronIconName, IconProps } from './types';
import { Icon } from './Icon';

const chevronDirectionMappings = {
  up: ChevronIconName.UP,
  down: ChevronIconName.DOWN,
  left: ChevronIconName.LEFT,
  right: ChevronIconName.RIGHT,
};

interface ChevronIconProps extends Pick<
  IconProps,
  'iconSize' | 'deprecated_onClick' | 'className'
> {
  direction: 'up' | 'down' | 'left' | 'right';
  style?: CSSProperties;
}

const ChevronIcon = ({ direction, iconSize, ...rest }: ChevronIconProps) => (
  <Icon
    iconName={chevronDirectionMappings[direction]}
    iconSize={iconSize}
    // pick the native html props only, and trim the styled-components
    // custom props so we avoids warrnings :)
    {...pick(rest, ['style', 'deprecated_onClick', 'className'])}
  />
);

export { ChevronIcon };
